export const TABS = [
  {
    key: "overview",
    label: "Overview",
    visible: true,
    tableKey: "overview",
    alwaysShow: true,
  },
  {
    key: "instagram_reel",
    label: "Reels",
    visible: true,
    tableKey: "reels",
    requiredPlatform: "instagram",
  },
  {
    key: "instagram_post",
    label: "Posts",
    visible: true,
    tableKey: "posts",
    requiredPlatform: "instagram",
  },
  {
    key: "instagram_carousel_post",
    label: "Carousel Posts",
    visible: true,
    tableKey: "carousel_posts",
    requiredPlatform: "instagram",
  },
  {
    key: "instagram_story",
    label: "Story",
    visible: true,
    tableKey: "story_blocks",
    requiredPlatform: "instagram",
  },
  {
    key: "tiktok_video",
    label: "TikTok Videos",
    visible: true,
    tableKey: "tt_videos",
    requiredPlatform: "tiktok",
  },
  {
    key: "youtube_video",
    label: "YouTube Videos",
    visible: true,
    tableKey: "yt_videos",
    requiredPlatform: "youtube",
  },
  {
    key: "youtube_short",
    label: "YouTube Shorts",
    visible: true,
    tableKey: "yt_shorts",
    requiredPlatform: "youtube",
  },
  {
    key: "linkedin_post",
    label: "LinkedIn Beitrag",
    visible: true,
    tableKey: "li_posts",
    requiredPlatform: "linkedin",
  },
  {
    key: "linkedin_newsletter",
    label: "LinkedIn Newsletter",
    visible: true,
    tableKey: "li_newsletters",
    requiredPlatform: "linkedin",
  },
  {
    key: "linkedin_video",
    label: "LinkedIn Videos",
    visible: true,
    tableKey: "li_videos",
    requiredPlatform: "linkedin",
  },
  {
    key: "pinterest_pin",
    label: "Pinterest Pins",
    visible: true,
    tableKey: "pin_posts",
    requiredPlatform: "pinterest",
  },
  {
    key: "podcast_episode",
    label: "Podcast Episodes",
    visible: true,
    tableKey: "podcast_episodes",
    requiredPlatform: "podcast",
  },
  {
    key: "other_item",
    label: "Other",
    visible: true,
    tableKey: "other_items",
    requiredPlatform: "other",
  },
  {
    key: "non_media_item",
    label: "Non Media Items",
    visible: false,
    tableKey: "non_media",
  },
  {
    key: "buyouts",
    label: "Buyouts",
    visible: true,
    tableKey: "buyouts",
    alwaysShow: true,
  },
  {
    key: "custom",
    label: "Sonstiges",
    visible: true,
    tableKey: "custom",
    alwaysShow: true,
  },
  {
    key: "overall-kosten",
    label: "Overall Kosten",
    visible: true,
    tableKey: "overall-kosten",
    alwaysShow: true,
  },
];

export const REELS_LIKE_COLUMNS = [
  { key: "influencer", label: "Influencer" },
  { key: "follower", label: "Follower", input: true },
  { key: "brutto", label: "Brutto Reichweite", input: false },
  { key: "impression", label: "Gesamt Impressionen", input: true },
  { key: "tkpFollower", label: "TKP Follower Advertiser", input: false },
  { key: "tkpImpression", label: "TKP Impressions Advertiser", input: false },
  { key: "views", label: "Reel Views (Laut Insights)", input: true },
  { key: "payout", label: "Influencer Payout", input: true },
  { key: "preis", label: "Influencer Preis (Tool)", input: false },
  { key: "ksa", label: "KSA Abgabe", input: false },
  { key: "advertiser", label: "Advertiser Preis inkl. KSA", dark: true },
];

/** Reel-like tables share one column set, but "Reel Views" only makes sense for the Reels tab - every other format gets its own views label. */
const buildReelsLikeColumns = (viewsLabel) =>
  REELS_LIKE_COLUMNS.map((column) => (column.key === "views" ? { ...column, label: viewsLabel } : column));

export const TABLES = {
  overview: {
    groups: [
      { label: "Influencer", keys: ["influencer"] },
      {
        label: "Channel Names",
        keys: [
          "instagram",
          "tiktok",
          "youtube",
          "linkedin",
          "pinterest",
          "podcastChannel",
          "otherChannel",
        ],
      },
      {
        label: "Scope IG",
        keys: ["igPost", "igCarousel", "igReel", "igStory"],
      },
      { label: "Scope TT", keys: ["ttVid"] },
      { label: "Scope YT", keys: ["ytVid", "ytReel"] },
      { label: "Sc. Link", keys: ["liBeitrag", "liNewsletter", "liVideo"] },
      { label: "Sc. Pin", keys: ["pinPost"] },
      { label: "Sc. Pod", keys: ["podcast"] },
      { label: "Sc. Other", keys: ["otherItem"] },
      { label: "Gesamt Media", keys: ["gapm", "tkpFl", "tkpImp"], dark: true },
    ],
    columns: [
      { key: "influencer", label: "" },
      { key: "instagram", label: "Instagram", input: true },
      { key: "tiktok", label: "TikTok", input: true },
      { key: "youtube", label: "YouTube", input: true },
      { key: "linkedin", label: "LinkedIn", input: true },
      { key: "pinterest", label: "Pinterest", input: true },
      { key: "podcastChannel", label: "Podcast", input: true },
      { key: "otherChannel", label: "Other", input: true },
      { key: "igPost", label: "Anzahl IG-Post", input: true },
      { key: "igCarousel", label: "Anzahl IG-Carousel", input: true },
      { key: "igReel", label: "Anzahl IG-Reel", input: true },
      { key: "igStory", label: "Anzahl IG-Story", input: true },
      { key: "ttVid", label: "Anzahl TT Vid.", input: true },
      { key: "ytVid", label: "Anzahl YT Vid.", input: true },
      { key: "ytReel", label: "Anzahl YT Shorts", input: true },
      { key: "liBeitrag", label: "Anzahl LI-Beitrag", input: true },
      { key: "liNewsletter", label: "Anzahl LI-Newsletter", input: true },
      { key: "liVideo", label: "Anzahl LI-Video", input: true },
      { key: "pinPost", label: "Anzahl Pin", input: true },
      { key: "podcast", label: "Anzahl Podcast", input: true },
      { key: "otherItem", label: "Anzahl Other", input: true },
      { key: "gapm", label: "GAPM", dark: true },
      { key: "tkpFl", label: "TKP GES.Fl", dark: true },
      { key: "tkpImp", label: "TKP GES Imp.", dark: true },
    ],
  },
  reels: {
    groups: [
      {
        label: "Instagram Reel",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Reel",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: REELS_LIKE_COLUMNS,
    rows: [],
  },
  posts: {
    groups: [
      {
        label: "Instagram Post",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Post",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Post Views (Laut Insights)"),
    rows: [],
  },
  carousel_posts: {
    groups: [
      {
        label: "Instagram Carousel Post",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Carousel Post",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Carousel Post Views (Laut Insights)"),
    rows: [],
  },
  story_blocks: {
    groups: [
      {
        label: "Instagram Story",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Story",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Story Views (Laut Insights)"),
    rows: [],
  },
  yt_videos: {
    groups: [
      {
        label: "YouTube Video",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "YouTube",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("YouTube Views (Laut Insights)"),
    rows: [],
  },
  yt_shorts: {
    groups: [
      {
        label: "YouTube Shorts",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Shorts",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("YouTube Shorts Views (Laut Insights)"),
    rows: [],
  },
  tt_videos: {
    groups: [
      {
        label: "TikTok Video",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "TikTok",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("TikTok Views (Laut Insights)"),
    rows: [],
  },
  li_posts: {
    groups: [
      {
        label: "LinkedIn Beitrag",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Beitrag",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("LinkedIn Beitrag Views (Laut Insights)"),
    rows: [],
  },
  li_newsletters: {
    groups: [
      {
        label: "LinkedIn Newsletter",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Newsletter",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("LinkedIn Newsletter Views (Laut Insights)"),
    rows: [],
  },
  li_videos: {
    groups: [
      {
        label: "LinkedIn Video",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Video",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("LinkedIn Video Views (Laut Insights)"),
    rows: [],
  },
  pin_posts: {
    groups: [
      {
        label: "Pinterest Pin",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Pin",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Pinterest Views (Laut Insights)"),
    rows: [],
  },
  podcast_episodes: {
    groups: [
      {
        label: "Podcast Episode",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Episode",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Podcast Views (Laut Insights)"),
    rows: [],
  },
  other_items: {
    groups: [
      {
        label: "Other",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Collaboration",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Views (Laut Insights)"),
    rows: [],
  },
  non_media: {
    groups: [
      {
        label: "Non Media Item",
        keys: ["avatar", "instagram", "follower", "brutto", "impression"],
      },
      {
        label: "Details",
        keys: [
          "tkpFollower",
          "tkpImpression",
          "views",
          "payout",
          "preis",
          "ksa",
          "advertiser",
        ],
      },
    ],
    columns: buildReelsLikeColumns("Views (Laut Insights)"),
    rows: [],
  },
  buyouts: {
    groups: [
      {
        label: "Buy-Out für Social Ads",
        keys: ["influencer", "anzahlBuyout", "buyoutUnitPrice"],
      },
      {
        label: "Gesamt",
        keys: ["gesamtBuyouts", "buyoutAdvertiser", "welcheBuyouts"],
      },
    ],
    columns: [
      { key: "influencer", label: "Influencer" },
      { key: "anzahlBuyout", label: "Anzahl Buyout Social Ads", input: true },
      { key: "buyoutUnitPrice", label: "Buy-Out für Social Ads", input: true },
      { key: "gesamtBuyouts", label: "Gesamt Buyouts", dark: true },
      {
        key: "buyoutAdvertiser",
        label: "Buyout Advertiser inkl. KSA",
        dark: true,
      },
      {
        key: "welcheBuyouts",
        label: "Welche Buyouts wurden eingekauft?",
        input: true,
      },
    ],
    rows: [],
  },
  custom: {
    groups: [{ label: "Sonstiges", keys: ["influencer"] }],
    columns: [{ key: "influencer", label: "Influencer" }],
    rows: [],
  },
  "overall-kosten": {
    groups: [
      {
        label: "Instagram Reel",
        keys: ["influencer", "ksaGesamt", "kostenAdvertiser", "payout"],
      },
      {
        label: "Overall kosten gesamt",
        keys: ["kommentar", "margeEur", "margeBuyouts", "margeMedia"],
      },
    ],
    columns: [
      { key: "influencer", label: "Influencer" },
      { key: "ksaGesamt", label: "KSA Abgabe gesamt", dark: true },
      { key: "kostenAdvertiser", label: "KOSTEN Advertiser", dark: true },
      { key: "payout", label: "Payout Influencer", dark: true },
      { key: "kommentar", label: "Kommentar zu den Fees", input: true },
      { key: "margeEur", label: "Marge in EUR", input: true },
      { key: "margeBuyouts", label: "Marge Buyouts & Co. in %", input: true },
      { key: "margeMedia", label: "Marge Media Budget in %", input: true },
    ],
    rows: [],
  },
};

export const REELS_LIKE_TABLE_KEYS = [
  "reels",
  "posts",
  "carousel_posts",
  "story_blocks",
  "yt_videos",
  "yt_shorts",
  "tt_videos",
  "li_posts",
  "li_newsletters",
  "li_videos",
  "pin_posts",
  "podcast_episodes",
  "other_items",
  "non_media",
];

/** Budget table media tabs: one tab maps to one action_type. */
export const REELS_LIKE_TABLE_KEY_TO_ACTION_TYPE = {
  reels: "instagram_reel",
  posts: "instagram_post",
  carousel_posts: "instagram_carousel_post",
  story_blocks: "instagram_story",
  tt_videos: "tiktok_video",
  yt_videos: "youtube_video",
  yt_shorts: "youtube_short",
  li_posts: "linkedin_post",
  li_newsletters: "linkedin_newsletter",
  li_videos: "linkedin_video",
  pin_posts: "pinterest_pin",
  podcast_episodes: "podcast_episode",
  other_items: "other_item",
  non_media: "non_media_item",
};

export const REELS_LIKE_SPLIT_SAVE_COLS = ["impression", "views", "payout"];
/** Debounce before save (ms) so users can finish typing. */
export const REELS_LIKE_SPLIT_DEBOUNCE_MS = 2200;
export const BUYOUT_SAVE_DEBOUNCE_MS = 1200;
export const BUYOUT_NOTES_DEBOUNCE_MS = 2200;

/** Overview scope column -> action types + budget tab keys for REELS_LIKE_SPLIT save; null = no API sync. */
export const SCOPE_KEY_SYNC_CONFIG = {
  igPost: { actionTypes: ["instagram_post"], splitTableKeys: ["posts"] },
  igCarousel: {
    actionTypes: ["instagram_carousel_post"],
    splitTableKeys: ["carousel_posts"],
  },
  igReel: { actionTypes: ["instagram_reel"], splitTableKeys: ["reels"] },
  igStory: {
    actionTypes: ["instagram_story"],
    splitTableKeys: ["story_blocks"],
  },
  ttVid: { actionTypes: ["tiktok_video"], splitTableKeys: ["tt_videos"] },
  ytVid: { actionTypes: ["youtube_video"], splitTableKeys: ["yt_videos"] },
  ytReel: { actionTypes: ["youtube_short"], splitTableKeys: ["yt_shorts"] },
  liBeitrag: { actionTypes: ["linkedin_post"], splitTableKeys: ["li_posts"] },
  liNewsletter: {
    actionTypes: ["linkedin_newsletter"],
    splitTableKeys: ["li_newsletters"],
  },
  liVideo: { actionTypes: ["linkedin_video"], splitTableKeys: ["li_videos"] },
  pinPost: { actionTypes: ["pinterest_pin"], splitTableKeys: ["pin_posts"] },
  podcast: {
    actionTypes: ["podcast_episode"],
    splitTableKeys: ["podcast_episodes"],
  },
  otherItem: {
    actionTypes: ["other_item"],
    splitTableKeys: ["other_items"],
    noAuthentication: true,
  },
};

export const OVERVIEW_SCOPE_KEYS = [
  "igPost",
  "igCarousel",
  "igReel",
  "igStory",
  "ttVid",
  "ytVid",
  "ytReel",
  "liBeitrag",
  "liNewsletter",
  "liVideo",
  "pinPost",
  "podcast",
  "otherItem",
];

export const ACTION_TYPE_TO_AUTH_PROVIDER = {
  instagram_post: "instagram",
  instagram_carousel_post: "instagram",
  instagram_reel: "instagram",
  instagram_story: "instagram",
  tiktok_video: "tiktok",
  youtube_video: "youtube",
  youtube_short: "youtube",
  linkedin_post: "linkedin",
  linkedin_video: "linkedin",
  linkedin_newsletter: "linkedin",
  pinterest_pin: "pinterest",
  podcast_episode: "podcast",
};

export const OTHER_BUDGET_CONFIG = {
  channelKey: "otherChannel",
  scopeKey: "otherItem",
  actionType: "other_item",
  tableKey: "other_items",
};

export function isOtherOverviewChannelKey(channelKey) {
  return channelKey === OTHER_BUDGET_CONFIG.channelKey;
}

export function isOtherScopeKey(scopeKey) {
  return scopeKey === OTHER_BUDGET_CONFIG.scopeKey;
}

export const AUTH_PROVIDER_ENUM_ORDER = [
  "instagram",
  "tiktok",
  "youtube",
  "pinterest",
  "linkedin",
  "podcast",
];

export const AUTH_PROVIDER_TO_CHANNEL_COLUMN = {
  instagram: "instagram",
  tiktok: "tiktok",
  youtube: "youtube",
  linkedin: "linkedin",
  pinterest: "pinterest",
  podcast: "podcastChannel",
};

export const OVERVIEW_PROVIDER_CONFIG = {
  instagram: {
    channelKey: "instagram",
    scopeKeys: ["igPost", "igCarousel", "igReel", "igStory"],
  },
  tiktok: {
    channelKey: "tiktok",
    scopeKeys: ["ttVid"],
  },
  youtube: {
    channelKey: "youtube",
    scopeKeys: ["ytVid", "ytReel"],
  },
  linkedin: {
    channelKey: "linkedin",
    scopeKeys: ["liBeitrag", "liNewsletter", "liVideo"],
  },
  pinterest: {
    channelKey: "pinterest",
    scopeKeys: ["pinPost"],
  },
  podcast: {
    channelKey: "podcastChannel",
    scopeKeys: ["podcast"],
  },
};

export const OVERVIEW_CHANNEL_KEY_TO_AUTH_PROVIDER = Object.entries(
  OVERVIEW_PROVIDER_CONFIG,
).reduce((acc, [provider, config]) => {
  acc[config.channelKey] = provider;
  return acc;
}, {});

export const OVERVIEW_SCOPE_KEY_TO_AUTH_PROVIDER = Object.entries(
  OVERVIEW_PROVIDER_CONFIG,
).reduce((acc, [provider, config]) => {
  config.scopeKeys.forEach((scopeKey) => {
    acc[scopeKey] = provider;
  });
  return acc;
}, {});

export function channelColumnForAuthProvider(provider) {
  return (
    AUTH_PROVIDER_TO_CHANNEL_COLUMN[normalizeAuthProvider(provider)] || null
  );
}

export function providerForOverviewChannelKey(channelKey) {
  return OVERVIEW_CHANNEL_KEY_TO_AUTH_PROVIDER[channelKey] || null;
}

export function providerForOverviewScopeKey(scopeKey) {
  return OVERVIEW_SCOPE_KEY_TO_AUTH_PROVIDER[scopeKey] || null;
}

export function overviewScopeKeysForProvider(provider) {
  return (
    OVERVIEW_PROVIDER_CONFIG[normalizeAuthProvider(provider)]?.scopeKeys || []
  );
}

/** @param {Set<string> | Iterable<string> | null | undefined} platforms */
export function platformSetHas(platforms, key) {
  if (!platforms) return false;
  if (typeof platforms.has === "function") return platforms.has(key);
  return Array.from(platforms).includes(key);
}

export function platformsSelectionIsEmpty(platforms) {
  if (platforms == null) return true;
  if (typeof platforms.size === "number") return platforms.size === 0;
  try {
    const it = platforms[Symbol.iterator]();
    return it.next().done === true;
  } catch {
    return true;
  }
}

/**
 * Empty / missing platforms = legacy campaign: do not hide channel / scope columns.
 * When at least one platform is selected, channels and scope columns not in the list are hidden.
 */
export function tabVisibleForCampaignPlatforms(tab, platforms) {
  if (tab.alwaysShow) return true;
  if (!tab.requiredPlatform) return true;
  if (platformsSelectionIsEmpty(platforms)) return true;
  return platformSetHas(platforms, tab.requiredPlatform);
}

/**
 * Payout/Preis/KSA figures that must never reach clients regardless of the per-campaign
 * visibility toggle. Not user-configurable: excluded from the PM's own visibility-toggle UI
 * (toggling them would have no effect on what the client sees) but always shown in the PM's
 * own working view.
 */
export const CLIENT_ALWAYS_HIDDEN_COLUMNS = new Set(['payout', 'preis', 'ksa', 'ksaGesamt', 'buyoutUnitPrice', 'gesamtBuyouts'])

export function forcedHiddenColumnsFromPlatforms(platforms) {
  if (platformsSelectionIsEmpty(platforms)) return {};

  return {
    ...(platformSetHas(platforms, "instagram")
      ? {}
      : {
          instagram: true,
          igPost: true,
          igCarousel: true,
          igReel: true,
          igStory: true,
        }),
    ...(platformSetHas(platforms, "tiktok")
      ? {}
      : { tiktok: true, ttVid: true }),
    ...(platformSetHas(platforms, "youtube")
      ? {}
      : { youtube: true, ytVid: true, ytReel: true }),
    ...(platformSetHas(platforms, "linkedin")
      ? {}
      : { linkedin: true, liBeitrag: true, liNewsletter: true, liVideo: true }),
    ...(platformSetHas(platforms, "pinterest")
      ? {}
      : { pinterest: true, pinPost: true }),
    ...(platformSetHas(platforms, "podcast")
      ? {}
      : { podcastChannel: true, podcast: true }),
    ...(platformSetHas(platforms, "other")
      ? {}
      : { otherChannel: true, otherItem: true }),
  };
}

/** Format tab (tab.key / action_type) -> the Overview "Anzahl X" scope column that represents it. */
export const TAB_KEY_TO_OVERVIEW_SCOPE_KEY = Object.entries(SCOPE_KEY_SYNC_CONFIG).reduce(
  (acc, [scopeKey, config]) => {
    (config.actionTypes || []).forEach((actionType) => {
      acc[actionType] = scopeKey;
    });
    return acc;
  },
  {}
);

/**
 * A format's whole tab (Posts, Carousel Posts, Story, ...) is hidden once the PM disables its
 * "Anzahl X" column in the Overview tab via the Visibility toggle - no point keeping an empty tab around.
 */
export function tabVisibleForOverviewColumnVisibility(tab, overviewVisibleColumns) {
  const scopeKey = TAB_KEY_TO_OVERVIEW_SCOPE_KEY[tab.key];
  if (!scopeKey) return true;
  if (!overviewVisibleColumns) return true;
  return overviewVisibleColumns[scopeKey] !== false;
}

export function normalizeAuthProvider(provider) {
  if (provider == null || provider === "") return "";
  if (typeof provider === "number" && AUTH_PROVIDER_ENUM_ORDER[provider]) {
    return AUTH_PROVIDER_ENUM_ORDER[provider];
  }
  return String(provider).toLowerCase();
}
